import _jsx from "@babel/runtime/helpers/jsx";

var _LinkIcon;

import React, { memo, useCallback } from 'react';
import { useIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import Media from 'react-media';
import ResponsiveMenu from 'components/ResponsiveMenu';
import ContainerDimensions from 'components/ContainerDimensions';
import { ListItem, Link, LinkOptionItem, LinkOption, LinkIcon } from './styles';
import { jsx as _jsx2 } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var mobileQuery = {
  minWidth: 320
};
var ResponsiveMenuWrapper = /*#__PURE__*/memo(function (_ref) {
  var menu = _ref.menu;

  var _useIntl = useIntl(),
      formatMessage = _useIntl.formatMessage;

  var renderLink = useCallback(function (_ref2) {
    var item = _ref2.item,
        _ref2$ref = _ref2.ref,
        ref = _ref2$ref === void 0 ? function () {} : _ref2$ref;
    return /*#__PURE__*/_jsx2(ListItem, {
      active: item.link === 'cards',
      ref: ref,
      children: /*#__PURE__*/_jsx(Link, {
        href: item.link,
        title: item.name
      }, void 0, item.name)
    }, item.link);
  }, []);
  var renderHiddenLink = useCallback(function (_ref3) {
    var item = _ref3.item;
    return /*#__PURE__*/_jsx(LinkOptionItem, {}, item.link, /*#__PURE__*/_jsx(LinkOption, {
      href: item.link,
      title: item.name,
      active: item.link === 'cards'
    }, void 0, item.name));
  }, []);
  var renderMoreBtn = useCallback(function (_ref4) {
    var toggle = _ref4.toggle,
        ref = _ref4.ref;
    var moreTitle = formatMessage({
      id: "links.more"
    });
    return /*#__PURE__*/_jsx2(_Fragment, {
      children: /*#__PURE__*/_jsxs(Link, {
        as: "button",
        type: "button",
        title: moreTitle,
        ref: ref,
        onTouchEnd: toggle,
        children: [moreTitle, _LinkIcon || (_LinkIcon = /*#__PURE__*/_jsx(LinkIcon, {
          name: "arrow"
        }))]
      })
    });
  }, [formatMessage]);
  var renderDesktopMenu = useCallback(function () {
    return /*#__PURE__*/_jsx(ContainerDimensions, {}, void 0, function (_ref5) {
      var width = _ref5.width;
      return /*#__PURE__*/_jsx(ResponsiveMenu, {
        items: menu,
        containerWidth: width,
        renderLink: renderLink,
        renderHiddenLink: renderHiddenLink,
        renderMoreBtn: renderMoreBtn,
        defaultItemsCount: 100
      });
    });
  }, [menu]);
  return /*#__PURE__*/_jsx(Media, {
    query: mobileQuery,
    defaultMatches: false,
    render: renderDesktopMenu
  });
});
ResponsiveMenuWrapper.defaultProps = {
  menu: null
};
export default withRouter(ResponsiveMenuWrapper);